import { createFileRoute } from "@tanstack/react-router";
import BlogEveningIOPNJ from "@/pages/BlogEveningIOPNJ";
import { routeHead } from "@/lib/route-head";

export const Route = createFileRoute("/evening-iop-new-jersey")({
  head: () => routeHead("/evening-iop-new-jersey"),
  component: BlogEveningIOPNJ,
});
